// hooks/useDatepicker.js
import { useEffect } from 'react';

export const useDatepicker = (onDateChange) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      if (window.$ && window.$.fn.datepicker) {
        window.$(".customDatepicker").datepicker({
          showOn: "button",
          buttonImageOnly: false,
          buttonText: "",
          onSelect: function(dateText, inst) {
            // Trigger React onChange event
            const event = new Event('input', { bubbles: true });
            this.value = dateText;
            this.dispatchEvent(event);
            // Call the callback if provided
            if (onDateChange) {
              onDateChange(this.name, dateText);
            }
          }
        });
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [onDateChange]);
};
